import { ReactNode, useMemo, useState } from "react";
import Game from "../components/Game";
import { GameMutator, GameState, MutationResult } from "../game/game";
import './Tutorial2.less'
import React from "react";
import tutorials from '../data/tutorials.json'
import { DehydratedGameState, hydrateGame } from "../game/hydrateGame";

interface TutorialProps {
  onTutorialComplete: ()=>void
}
function Tutorial(props:TutorialProps) {
    const [tutorialStep, setTutorialStep] = useState(0)
    const isHoverableDevice = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;
    const [a,b,c] = tutorials as DehydratedGameState[]
    const tutorialState1: GameState = useMemo(() => hydrateGame(a), [a])
  
    const tutorialState2: GameState = useMemo(() => hydrateGame(b), [b])
    const tutorialState3: GameState = useMemo(() => hydrateGame(c), [c])

    return (
    <TutorialWrapper className='tutorial' step={tutorialStep} 
      footer={<button className="tutorial-footer" onClick={props.onTutorialComplete}>Skip Tutorial ⟶</button>}
    >
      <Game
        initialState={tutorialState1}
        baseKey={null}
        moves={null}
 
        description='Tap the mutation to unscramble the word!'
        disableInput={tutorialStep !== 0}
        onUndo={() => {
          
        }}
        onMutatorSelected={(_:GameMutator, __:MutationResult) => {
         
        }}
        onGameCompleted={()=>{
            setTutorialStep(1)
        }}
      />
      <Game
        initialState={tutorialState2}
        baseKey={null}
        moves={null}

        description={<>Apply the mutations in the right order to unscramble the word <span className="pretty">“organize”</span></>}
        disableInput={tutorialStep !== 1}
        onUndo={() => {
          
        }}
        onMutatorSelected={(_:GameMutator, __:MutationResult) => {
         
        }}
        onGameCompleted={()=>{
            setTutorialStep(2)
        }}
      />
    <Game
        initialState={tutorialState3}
        baseKey={null}
        moves={null}

        description={<>Apply four mutations to unscramble all four words at once! {!isHoverableDevice && "Tap and hold on a mutation to preview it's effect!"}</>}
        disableInput={tutorialStep !== 2}
        onUndo={() => {
          
        }}
        onMutatorSelected={(_:GameMutator, __:MutationResult) => {
         
        }}
        onGameCompleted={()=>{
          setTutorialStep(3)
          setTimeout(()=>{
            props.onTutorialComplete()
          }, 300);
        }}
      />
    </TutorialWrapper>
  );

}

interface TutorialWrapperProps {
  children: ReactNode,
  step: number,
  style?: React.CSSProperties
  className: string
  pastClassName?: string
  currentClassName?: string
  futureClassName?: string,
  footer: ReactNode
}
function TutorialWrapper({children, footer, step, className, pastClassName='past', currentClassName='current', futureClassName='future', style}:TutorialWrapperProps){
  return <div className={className} style={style}>
    {React.Children.map(children, (child, i) => {
      if(i < step){
        return React.cloneElement(child as any, {className: pastClassName})
      }else if(i === step){
        return React.cloneElement(child as any, {className: currentClassName})
      }else{
        return React.cloneElement(child as any, {className: futureClassName})
      }
    })}
    {footer}
  </div>
}
export default Tutorial;
